<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :queryOnLoad="queryOnLoad" :confKey="confKey" :configAuto="true" :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import servcClaimApi from '../../api/servcClaim'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbResultColConf from '../query/ResultColConf';
    import SwbResultTable from '../query/ResultTable';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-acc-claim-list-select',
        props: {
            isShowSelection: {
                type: Boolean,
                default: false
            },
            forAuthFlag: {
                type: Boolean,
                default: false
            },
            isDevcFlag: {
                type: Boolean,
                default: false
            },
            checkedItem: {
                type: Object,
                default: null
            },
            selectIds: {
                type: Array,
                default: null
            },
            checkservcTypeId: {
                type: Number,
                default: null
            },
            goodsCatId: {
                type: Number,
                default: null
            },
            goodsCatIds: {
                type: Array,
                default: null
            },
            // 设备分类goodsCatIds、服务分类servcCatId都传时有效，设备分类没有查到数据时，查服务分类
            allSearchFlag: {
                type: Boolean,
                default: null
            }
        },
        desc: '配件要求管理',
        data: function () {
            return {
                tableHeight: 600,
                queryOnLoad: true,
                confKey: null,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 230,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
                allTableState: [],
                tableState: [],
                checkServcTypeId: null,
                servcWorkTypeMap: {},
                searchGoods: true
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.allTableState = getEnumList('workServcType') || [];
            this.servcWorkTypeMap = getEnumMap("workServcType", "value2text");
            let isShowSelection = this.isShowSelection == null ? true : this.isShowSelection;
            if(isShowSelection) {
                this.multiSelect = true;
                this.multiPageSelect = true;
            } else {
                this.multiSelect = false;
                this.multiPageSelect = false;
                this.rowNoShow = true;
            }
            if(Utils.isTrue(this.isDevcFlag)) {
                this.searchGoods = true;
            } else {
                this.searchGoods = false;
            }
            this.changeSearch();
        },
        mounted() {
            //
            this.initResultTable();

        },
        methods: {
            changeSearch(){
                if(Utils.isTrue(this.searchGoods)) {
                    if(Utils.isTrue(this.forAuthFlag)) {
                        this.confKey = "swb-devc-acc-claim-list-forAuth-select";
                    } else {
                        this.confKey = "swb-devc-acc-claim-list-forSelf-select";
                    }
                } else {
                    if(Utils.isTrue(this.forAuthFlag)) {
                        this.confKey = "swb-servc-acc-claim-list-forAuth-select";
                    } else {
                        this.confKey = "swb-servc-acc-claim-list-forSelf-select";
                    }
                }
            },
            onConfigReady: function () {
                let self = this;
                if(Utils.isNoB(this.checkservcTypeId)) {
                    this.initTableState(function () {
                        let query_model_ctrl = self.$refs['query_model_ctrl'];
                        let fieldInfo = {};
                        fieldInfo["servcTypeId"] = {
                            "dataList": self.tableState
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });

                } else {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let fieldInfo = {};
                    fieldInfo["servcTypeId"] = {
                        "hidden": true
                    };
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initTableState(callback){
                let self = this;
                let theLoading = MsgBox.loading();
                servcClaimApi.getServcAccClaimServcType({
                    goodsFlag: self.isDevcFlag,
                    forAuthFlag: self.forAuthFlag,
                }, function (result) {
                    theLoading.hide();
                    if(result.type == 'info') {
                        let servcTypeIds = result.data;
                        let allTableStateMap = self.allTableState.toMap('value');
                        if(servcTypeIds != null && servcTypeIds.length > 0) {
                            let tableState = [{
                                value: null,
                                label: "- 全部 -"
                            }];
                            servcTypeIds.forEach(function (servcType) {
                                let table = allTableStateMap[servcType];
                                let code = {
                                    value: table.value,
                                    label: table.text,
                                }
                                tableState.push(code);
                            });
                            self.tableState = tableState;
                        } else {
                            self.tableState = [];
                        }
                        if(typeof callback == 'function') {
                            callback();
                        }
                    } else {
                        MsgBox.warning(resultData.message);
                    }
                });
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                        'servcTypeId': function (row, colName, colValue, rowIndex, colConf) {
                            return self.servcWorkTypeMap[row.servcTypeId];
                        },
                        'goodsCatLevel': function (row, colName, colValue, rowIndex, colConf) {
                            if(colValue == 1) {
                                return '<span>一级</span>';
                            } else if(colValue == 2) {
                                return '<span>二级</span>';
                            } else {
                                return '<span>三级</span>';
                            }
                        },
                        'servcCatLevel': function (row, colName, colValue, rowIndex, colConf) {
                            if(colValue == 1) {
                                return '<span>一级</span>';
                            } else if(colValue == 2) {
                                return '<span>二级</span>';
                            } else {
                                return '<span>三级</span>';
                            }
                        },
                        'srcFlag': function (row, colName, colValue, rowIndex, colConf) {
                            if(row.srcFlag == -1) {
                                return '<span>无要求</span>';
                            } else if(row.srcFlag == 0) {
                                return '<span>服务商</span>';
                            } else if(row.srcFlag == 2) {
                                return '<span>授权商</span>';
                            } else {
                                return '<span>零售商</span>';
                            }
                        },
                        'disabled': function (row, colName, colValue, rowIndex, colConf) {
                            if(row.disabled) {
                                return '<span>' + "禁用" + '</span>';
                            } else {
                                return '<span>' + "启用" + '</span>';
                            }
                        },
                        'actions': function (row, colName, colValue, rowIndex) {

                        }
                    },
                    /* 单元格按钮点击处理函数 */
                    {
                        'actions': function (row, colName, colValue, rowIndex, btnName) {

                        }
                    }
                );
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            handleTabClick(status){
                this.checkServcTypeId = status.value;
                this.pageNumber = 1;
                this.getDataList();
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.forAuthFlag = this.forAuthFlag;
                if(!Utils.isNoB(this.checkservcTypeId)) {
                    filterItems.servcTypeId = this.checkservcTypeId;
                }
                if(this.allSearchFlag != null && this.allSearchFlag) {
                    if(this.searchGoods) {
                        filterItems.goodsFlag = true;
                        filterItems.goodsCatIds = self.goodsCatIds;
                    }
                } else {
                    filterItems.goodsFlag = this.isDevcFlag;
                    if(!Utils.isNoB(self.goodsCatId)) {
                        filterItems.goodsCatId = self.goodsCatId;
                    }
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                servcClaimApi.getServcAccClaimList(postData, function (result) {
                    if(result.type == "info") {
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.renderTable(result.data.rows, pagination);
                        theLoading.hide();
                        if(self.allSearchFlag != null && self.allSearchFlag && self.searchGoods && self.pageNumber == 1 && self.totalCount == 0) {
                            self.searchGoods = false;
                            self.changeSearch();
                            self.getDataList();
                        }
                    } else {
                        theLoading.hide();
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                if(this.isShowSelection) {
                    let selectList = this.getTableSelection() || [];
                    if(selectList.length > 0) {
                        result.type = "info";
                        result.data = selectList;
                    } else {
                        result.type = "warn";
                        result.message = "请选择配件要求";
                    }
                } else {
                    let select = this.getTableSelection();
                    if(!Utils.isNoB(select) && select.id != null) {
                        result.type = "info";
                        result.data = select;
                    } else {
                        result.type = "warn";
                        result.message = "请选择配件要求";
                    }
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcClaim/AccClaimForSelect.vue